(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bosen-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bosen-navigation')) {
    customElements.define('bosen-navigation', class extends HTMLElement {
      connectedCallback() {
        this.events = new AbortController();
        this.desktop = matchMedia('(min-width: 1280px)');
        this.hover = matchMedia('(hover: hover) and (pointer: fine)');
        this.host = this.closest('.section-header');
        this.nav = this.querySelector('.bn-navigation');
        this.menuButton = this.querySelector('[data-menu-toggle]');
        this.categories = [...this.querySelectorAll('[data-category]')];
        this.allProductsLink = this.querySelector('[data-all-products]');
        this.dialogs = [...this.querySelectorAll('dialog')];
        this.scrim = this.querySelector('[data-scrim]');
        this.searchInput = this.querySelector('[data-search-input]');
        this.lastScroll = window.scrollY;
        this.inertNodes = [];
        this.on = (target, event, handler) => target.addEventListener(event, handler, {signal:this.events.signal});
        this.on(this, 'click', event => this.handleClick(event));
        this.on(this, 'keydown', event => this.handleKey(event));
        this.on(this, 'focusin', () => {this.host.classList.remove('bn-away'); this.lastScroll = window.scrollY; this.measure();});
        this.on(this.searchInput, 'input', () => this.search());
        this.on(this.desktop, 'change', () => {this.closeMenu(false); this.closeCategories(); this.measure();});
        this.on(window, 'resize', () => this.measure());
        this.on(window, 'scroll', () => this.scrollHeader());
        this.on(document, 'click', event => {if (!this.contains(event.target)) this.closeCategories();});
        this.on(document, 'focusin', event => {if (!this.contains(event.target)) this.closeCategories();});
        this.on(this.allProductsLink, 'pointerenter', () => {if (this.desktop.matches) this.closeCategories();});
        this.on(this.allProductsLink, 'focus', () => this.closeCategories());
        this.categories.forEach(category => {
          this.on(category, 'pointerenter', () => {
            if (this.desktop.matches && this.hover.matches) {
              clearTimeout(this.hoverTimer); clearTimeout(this.leaveTimer);
              this.hoverTimer = setTimeout(() => this.openCategory(category), 130);
            }
          });
          this.on(category, 'pointerleave', () => {
            clearTimeout(this.hoverTimer);
            if (this.desktop.matches && this.hover.matches) this.leaveTimer = setTimeout(() => this.closeCategory(category), 200);
          });
        });
        this.dialogs.forEach(dialog => {
          this.on(dialog, 'close', () => {
            if (dialog.dataset.dialog === 'search') {clearTimeout(this.searchTimer); this.searchRequest?.abort();}
            if (dialog.dataset.dialog === 'cart') this.cartRequest?.abort();
            if (!this.dialogs.some(item => item.open)) {
              this.unlock();
              const target = this.launcher?.getClientRects().length ? this.launcher : this.menuButton;
              target?.focus();
            }
          });
          this.on(dialog, 'click', event => {
            if (event.target !== dialog) return;
            const box = dialog.getBoundingClientRect();
            if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
          });
        });
        this.resizeObserver = new ResizeObserver(() => this.measure());
        this.resizeObserver.observe(this);
        this.measure();
      }
      disconnectedCallback() {
        this.dialogs.forEach(dialog => {if (dialog.open) dialog.close();});
        this.events.abort(); this.resizeObserver.disconnect(); this.searchRequest?.abort(); this.cartRequest?.abort();
        clearTimeout(this.searchTimer); clearTimeout(this.hoverTimer); clearTimeout(this.leaveTimer); this.unlock(); this.restoreBackground();
      }
      measure() {
        const bottom = Math.max(0, this.getBoundingClientRect().bottom);
        this.style.setProperty('--bn-bottom', `${bottom}px`);
      }
      scrollHeader() {
        const y = window.scrollY;
        if (y < 30) {
          this.host.classList.remove('bn-away'); this.lastScroll = y; return;
        }
        if (this.dataset.sticky !== 'true' || this.classList.contains('bn-menu-is-open') || this.dialogs.some(dialog => dialog.open) || this.categories.some(category => category.open) || this.contains(document.activeElement) || this.host.querySelector('cart-notification .cart-notification.active')) {
          this.lastScroll = y; return;
        }
        if (Math.abs(y - this.lastScroll) <= 8) return;
        this.host.classList.toggle('bn-away', y > this.lastScroll && y > 220);
        this.lastScroll = y;
      }
      handleClick(event) {
        const opener = event.target.closest('[data-open]');
        if (opener) {event.preventDefault(); this.openDialog(opener.dataset.open, opener); return;}
        if (event.target.closest('[data-close]')) {event.target.closest('dialog').close(); return;}
        if (event.target.closest('[data-menu-toggle]')) {this.classList.contains('bn-menu-is-open') ? this.closeMenu() : this.openMenu(); return;}
        if (event.target.closest('[data-close-menu]')) {this.closeMenu(); return;}
        if (event.target.closest('[data-scrim]')) {this.closeCategories(); return;}
        if (event.target.closest('[data-submit-search]')) {this.querySelector('.bn-search-form').requestSubmit(); return;}
        const back = event.target.closest('[data-back]');
        if (back) {const category = back.closest('[data-category]'); this.closeCategory(category); category.querySelector('summary').focus(); return;}
        const summary = event.target.closest('summary.bn-nav-link');
        if (summary) {event.preventDefault(); const category = summary.parentElement; category.open ? this.closeCategory(category) : this.openCategory(category);}
      }
      handleKey(event) {
        if (event.key === 'Escape' && !this.dialogs.some(dialog => dialog.open)) {
          const category = this.categories.find(item => item.open);
          if (category) {event.preventDefault(); this.closeCategory(category); category.querySelector('summary').focus();}
          else if (this.classList.contains('bn-menu-is-open')) {event.preventDefault(); this.closeMenu();}
        }
        if (event.key === 'Tab' && this.classList.contains('bn-menu-is-open')) {
          const items = [...this.querySelectorAll('a[href],button,summary')].filter(item => item.getClientRects().length && !item.closest('[inert]') && !item.disabled);
          if (event.shiftKey && document.activeElement === items[0]) {event.preventDefault(); items.at(-1).focus();}
          else if (!event.shiftKey && document.activeElement === items.at(-1)) {event.preventDefault(); items[0].focus();}
        }
      }
      openCategory(category) {
        clearTimeout(this.hoverTimer); clearTimeout(this.leaveTimer);
        this.closeCategories(); this.host.classList.remove('bn-away'); this.measure();
        category.open = true; category.querySelector('summary').setAttribute('aria-expanded', 'true');
        this.scrim.hidden = !this.desktop.matches;
        if (!this.desktop.matches) {
          category.querySelector('summary').inert = true;
          this.categories.filter(item => item !== category).forEach(item => item.inert = true);
          this.querySelector('.bn-mobile-utility').inert = true;
          this.allProductsLink.inert = true;
          this.nav.scrollTop = 0; category.querySelector('[data-back]').focus();
        }
      }
      closeCategory(category) {
        category.open = false; category.querySelector('summary').setAttribute('aria-expanded', 'false');
        category.querySelector('summary').inert = false;
        this.categories.forEach(item => item.inert = false);
        this.querySelector('.bn-mobile-utility').inert = false;
        this.allProductsLink.inert = false;
        if (!this.categories.some(item => item.open)) this.scrim.hidden = true;
      }
      closeCategories() {clearTimeout(this.hoverTimer); clearTimeout(this.leaveTimer); this.categories.forEach(category => this.closeCategory(category));}
      lock() {
        if (this.savedOverflow !== undefined) return;
        this.savedOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
      }
      unlock() {
        if (this.savedOverflow !== undefined) {document.body.style.overflow = this.savedOverflow; this.savedOverflow = undefined;}
      }
      restoreBackground() {this.inertNodes.forEach(([node,value]) => node.inert = value); this.inertNodes = [];}
      openMenu() {
        this.host.classList.remove('bn-away'); this.measure(); this.lock();
        this.classList.add('bn-menu-is-open'); this.menuButton.setAttribute('aria-expanded','true');
        this.setAttribute('role','dialog'); this.setAttribute('aria-modal','true'); this.setAttribute('aria-label',this.nav.getAttribute('aria-label'));
        for (const node of document.body.children) {
          if (node === this.host || node.contains(this) || node.tagName === 'SCRIPT' || node.tagName === 'STYLE') continue;
          this.inertNodes.push([node,node.inert]); node.inert = true;
        }
        this.nav.querySelector('[data-close-menu]').focus();
      }
      closeMenu(focus = true) {
        this.classList.remove('bn-menu-is-open'); this.menuButton.setAttribute('aria-expanded','false');
        this.removeAttribute('role'); this.removeAttribute('aria-modal'); this.removeAttribute('aria-label');
        this.closeCategories();
        if (!this.dialogs.some(dialog => dialog.open)) this.unlock();
        this.restoreBackground();
        if (focus) this.menuButton.focus();
      }
      openDialog(name, launcher) {
        if (this.classList.contains('bn-menu-is-open')) this.closeMenu(false);
        this.closeCategories(); this.launcher = launcher; this.host.classList.remove('bn-away');
        const dialog = this.querySelector(`[data-dialog="${name}"]`);
        this.dialogs.forEach(item => {if (item.open) item.close();});
        dialog.showModal(); this.lock();
        if (name === 'search') {this.searchInput.focus(); if (this.searchInput.value.trim()) this.search();}
        if (name === 'cart') this.loadCart();
      }
      search() {
        clearTimeout(this.searchTimer); this.searchRequest?.abort();
        const q = this.searchInput.value.trim();
        const results = this.querySelector('[data-search-results]');
        const status = this.querySelector('[data-search-status]');
        results.replaceChildren(); status.textContent = '';
        this.querySelector('[data-search-discover]').hidden = Boolean(q);
        this.querySelector('[data-submit-search]').hidden = !q;
        if (!q) return;
        status.textContent = this.dataset.loading;
        this.searchTimer = setTimeout(async () => {
          this.searchRequest = new AbortController();
          try {
            const url = new URL(`${this.dataset.searchUrl}.json`, location.origin);
            url.search = new URLSearchParams({q,'resources[type]':'product','resources[limit]':'8','resources[options][unavailable_products]':'last'});
            const response = await fetch(url, {signal:this.searchRequest.signal});
            if (!response.ok) throw new Error('Search unavailable');
            const data = await response.json();
            if (q !== this.searchInput.value.trim()) return;
            const products = data.resources.results.products || [];
            products.forEach(product => {
              const a = document.createElement('a'); a.href = product.url;
              const source = product.featured_image?.url || product.image;
              if (source) {const img = document.createElement('img'); img.src = source; img.alt = ''; img.width = 300; img.height = 230; a.append(img);}
              const title = document.createElement('span'); title.textContent = product.title; a.append(title); results.append(a);
            });
            status.textContent = products.length ? this.dataset.resultCount.replace('[count]', products.length) : this.dataset.empty;
          } catch (error) {if (error.name !== 'AbortError') status.textContent = this.dataset.error;}
        }, 220);
      }
      async loadCart() {
        this.cartRequest?.abort(); this.cartRequest = new AbortController();
        const status = this.querySelector('[data-cart-status]');
        const list = this.querySelector('[data-cart-items]');
        const footer = this.querySelector('[data-cart-footer]');
        const continueLink = this.querySelector('[data-cart-continue]');
        status.textContent = this.dataset.loading; list.replaceChildren(); footer.hidden = true; continueLink.hidden = false;
        continueLink.href = continueLink.dataset.defaultUrl; continueLink.textContent = continueLink.dataset.continueLabel;
        try {
          const response = await fetch(`${this.dataset.cartUrl}.js`, {signal:this.cartRequest.signal});
          if (!response.ok) throw new Error('Cart unavailable');
          const cart = await response.json();
          const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:cart.currency}).format(value / 100);
          status.textContent = cart.item_count ? '' : this.dataset.cartEmpty;
          const count = this.querySelector('.bn-cart-count'); if (count) count.textContent = cart.item_count;
          cart.items.forEach(item => {
            const row = document.createElement('div'); row.className = 'bn-cart-line';
            if (item.image) {const img = document.createElement('img'); img.src = item.image; img.alt = ''; img.width = 90; img.height = 100; row.append(img);}
            const info = document.createElement('div');
            const a = document.createElement('a'); a.href = item.url; a.textContent = item.product_title; info.append(a);
            if (item.variant_title) {const variant = document.createElement('p'); variant.textContent = item.variant_title; info.append(variant);}
            const price = document.createElement('p'); price.textContent = `${item.quantity} × ${money(item.final_price)}`; info.append(price); row.append(info); list.append(row);
          });
          footer.hidden = !cart.item_count; continueLink.hidden = Boolean(cart.item_count);
          this.querySelector('[data-cart-total]').textContent = money(cart.total_price);
        } catch (error) {
          if (error.name !== 'AbortError') {status.textContent = this.dataset.cartError; continueLink.href = this.dataset.cartUrl; continueLink.textContent = continueLink.dataset.cartLabel;}
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bosen-reading-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bosen-reading-guide')) {
    customElements.define('bosen-reading-guide', class extends HTMLElement {
      connectedCallback() {
        this.build = () => {
          const content = document.getElementById(this.dataset.contentId);
          if (!content) return;
          const headings = [...content.querySelectorAll('h2, h3')].filter(heading => heading.textContent.trim());
          const list = this.querySelector('ol');
          list.replaceChildren();
          this.hidden = headings.length < 2;
          if (this.hidden) return;
          headings.forEach((heading, index) => {
            if (!heading.id) {
              const base = this.dataset.contentId + '-heading-' + (index + 1);
              let id = base;
              let suffix = 1;
              while (document.getElementById(id)) id = base + '-' + suffix++;
              heading.id = id;
            }
            heading.tabIndex = -1;
            const item = document.createElement('li');
            if (heading.tagName === 'H3') item.classList.add('bosen-reading-guide__sub');
            const link = document.createElement('a');
            link.href = '#' + encodeURIComponent(heading.id);
            link.textContent = heading.textContent.trim();
            link.addEventListener('click', () => heading.focus({ preventScroll: true }));
            item.append(link);
            list.append(item);
          });
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.build, { once: true });
        else this.build();
      }
      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.build);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
